'use strict';

const FAQ = (function() {

	// var URL = 'faq.json';
	let DATA = 0;
	let FAQ = {

		init: function(){

			DATA = JSON.parse($('#data-faq').val()).faq;
			$('#data-faq').remove();

			let arrayQuestions = [];

			$.each(DATA, (categoryIndex, category)=> {
				$.each(category.itens, (questionIndex, question)=> {
					let item = {};
					item.id = question.id;
					item.text = question.title;
					item.table = question.table;

					item.category = question.category || categoryIndex;

					arrayQuestions.push(item);
				});
			});

			// console.info(arrayQuestions)

			// Select2
			(function(){

				const formatRepo = (repo)=> {
					if (repo.loading) {
						return repo.text;
					}
					const regEx = new RegExp( $('.select2-search__field')[0].value , "gi");
					const str = repo.text.replace(regEx, (a,b)=>{
						return `<bold>${a}</bold>`;
					})
					const markup = `<div class='select2-result clearfix'>
									<a href="" data-id="${ repo.id }" data-category="${ repo.category }" class='select2-result__title'>${ str }/</a>
									</div>`;

					return markup;
				}
				const formatRepoSelection = (repo)=> {
					if(repo.id !== ""){
						console.info(repo)
						if(repo.category !== undefined){
							console.info(repo.category)
							location.assign("/faq/perguntas-frequentes/#"+repo.category+"-"+repo.id + '/');
						}
					}
					return repo.text || repo.id;
				}

				// resize select2
				var widthReference;

				function resizeSelect2() {
						widthReference = $('.form-input-button.form-input-select-2').width();
						$('span.select2-results').css('width', widthReference);
				}

				var scrollTop, elementOffset, distance, windowHeight;
				var elementBase = $('.form-input-select-2');

				function animateToTopElement(w, d) {
					if((w - d) < 300) {
						$('html, body').scrollTop($(elementBase).offset().top - 100);
					}
				}

				function fixSelect2Appear() {
					$('[select2-faq]').on('select2:open', function (e) {
						scrollTop     = $(window).scrollTop(),
						windowHeight = $(window).height(),
						elementOffset = $(elementBase).offset().top,
						distance      = (elementOffset - scrollTop);

						animateToTopElement(windowHeight, distance);
					});
				}

				var scrollValue = 0;
				var scrollTimeout = false;

				$(window).bind('mousewheel', function(event) {
			    if (event.originalEvent.wheelDelta >= 0) {
			        $('[select2-faq]').select2('close');

							var scrolled = $(document).scrollTop() - scrollValue;
							scrollValue = $(document).scrollTop();

							if(scrolled > 50){
								$('[select2-faq]').select2('close');
							}
			    }
			});

				$(window).resize(function(event) {
					resizeSelect2()
				});

				// Select2
				$('[select2-faq]').select2({
					language: 'pt-BR',
					placeholder: 'DIGITE SUA DÚVIDA',
					escapeMarkup: function (markup) { return markup; }, // let our custom formatter work
					minimumInputLength: 2,
					maximumInputLength: 20,
					"language": {
						"noResults": ()=>{
							return "Nenhum resultado encontrado";
						}
					},
					initSelection: function (element, callback) {
						$(categories).each(function () {
							if (this.id == element.val()) {
								callback(this);
								return;
							}
						})
					},
					templateResult: formatRepo,
					templateSelection: formatRepoSelection,
					data: arrayQuestions
				}).on('select2:open', function(e) {
				    fixSelect2Appear()
				});

				resizeSelect2()

			})();


			window.onhashchange = (e)=>{
				var hash = document.location.hash.split('#')[1];
				console.info(hash)
			}


		},

		load: function(category){
			return category === undefined ? DATA : DATA[category];
		},

		build:function(category, id){

			const currentDATA = this.load(category)
			let $targetFAQ;

			if(category === 'hero' && !$('.perguntas-frequentes').length){
				$targetFAQ = $('.faq-main-questions .faq-questions');
				$targetFAQ.html('');
				$.each(currentDATA.itens, function(index, val) {
					const template = `<div class="col-12 col-4-m faq-main-question" id="${ category }-${ val.id }"><a href="perguntas-frequentes/#${ category }-${ val.id }">${ val.title }</a><span>${ val.category }</span></div>`;
					$targetFAQ.append(template);
				});

			} else if(category !== undefined && currentDATA !== undefined) {

				$('.faq h1.has-icon').html(`<i class="hero-icon ${ currentDATA.icon }"></i>${ currentDATA.title }`);

				let active;
				let icons;
				$targetFAQ = $('.faq-questions');
				$targetFAQ.html('');

				$.each(currentDATA.itens, function(index, val) {

					if(val.id == id){
						active = 'display:block;'
						icons = '<i class="fa fa-plus" style="display: none;"></i><i class="fa fa-minus" style="display: inline;"></i>';
					} else {
						active = ''
						icons = '<i class="fa fa-plus"></i><i class="fa fa-minus"></i>';
					}

					const template = `<div class="row faq-question" id="${ val.category }-${ val.id }" data-id="${ val.id }"><div class="col-12"><h3>${ icons }${ val.title }</h3><div class="faq-answer" style="${ active }"><p>${ val.answer }</p> ${ val.table } </div></div></div>`;
					$targetFAQ.append(template);
				});

			} else {

				$('.faq h1'). html(`<i class="hero-icon icon-block"></i>  Ops, nenhuma pergunta encontrada`)
				$('.faq-questions').html(``);
			}
		}
	}

	return FAQ;
}());



(()=> {
	'use strict';

	if( $('#data-faq').length ){

		FAQ.init();

		if( $('.faq-main-questions').length ){
			FAQ.build('hero');
		} else {
			let hash = document.location.hash.split('#')[1];
			let id = 0;
			if(hash.split("-").length == 2){
				id = hash.split("-")[1];
				hash = hash.split("-")[0];
			}
			FAQ.build(hash, id);
		}

	}

	// faq.js
	$('.faq .faq-question h3').on('click', function(e) {
		e.preventDefault();

		$('+ .faq-answer', this).stop().slideToggle();
		$('.fa-minus', this).stop().toggle();
		$('.fa-plus', this).stop().toggle();
	})

})();
